import { render, staticRenderFns } from "./IconRightTop2.vue?vue&type=template&id=70cb8b4a&"
import script from "./IconRightTop2.vue?vue&type=script&lang=js&"
export * from "./IconRightTop2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cb8b4a')) {
      api.createRecord('70cb8b4a', component.options)
    } else {
      api.reload('70cb8b4a', component.options)
    }
    module.hot.accept("./IconRightTop2.vue?vue&type=template&id=70cb8b4a&", function () {
      api.rerender('70cb8b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconRightTop2.vue"
export default component.exports